module.exports = __webpack_public_path__ + "static/img/avatar3.b5b44e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar/avatar3.png
// module id = Xbkv
// module chunks = 6